import { Box, Button, Card, CircularProgress, Container, IconButton, Input, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import CommonTable from '../../common/CommonTable'
import axios from 'axios'
import { API_URL } from '../../utils/constants'
import DataTable from '../../common/dataTable'
import TablePagination from '../../common/tablePagination'
import QueryTable from '../../common/queryTable'
import { useDispatch } from 'react-redux'
import commonActions from '../../redux/common/actions'

import { IoEye, IoEyeOff } from 'react-icons/io5'

const QueryTool = () => {
    let itemsPerPage = 10
    const [isShow, setIsShow] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [query, setQuery] = useState("")
    const [tableData, setTableData] = useState([])
    // const [currentItems, setCurrentItems] = useState([])
    const [columnData, setColumnData] = useState([])
    const [passwordValue, setPasswordValue] = useState("")
    const [itemOffset, setItemOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const dispatch = useDispatch()
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    const handleSubmit = () => {
        let value = passwordValue
        if (value.trim() === "") {
            alert("Please enter password to continue")
            return
        } else if (value === "Test@123") {
            setIsShow(true)
            alert("Login Success")
        } else {
            alert("The Password you entered is wrong please try again")
        }

    }
    const onClickRunQuery = async () => {
        setTableData([])
        setIsLoading(true)
        try {
            await axios.post(`${API_URL}/dev/db/query/tool`, {
                query,
                password: passwordValue
            }).then(res => {
                dispatch({
                    type: commonActions.SET_ALERT,
                    payload: {
                        status: res?.data?.statusCode === 200 ? "success" : "failed",
                        show: true,
                        message: res?.data?.message,
                    },
                })
                setTimeout(() => {
                    dispatch({
                        type: commonActions.SET_ALERT,
                        payload: {
                            status: null,
                            show: false,
                            message: null,
                        },
                    })
                }, 3000)
                if (res.data.statusCode === 200) {
                    setTableData(res.data.data)
                    let columns = [];
                    for (let key in res.data.data[0]) {
                        let obj = {
                            field: key,
                            headerName: key,
                            // flex:1
                            // sortOption: true,
                        }
                        if (key == "db_response") {
                            obj["flex"] = 1
                        }
                        // key == "db_message" && obj["flex"] = 1
                        columns.push(obj)
                    }
                    setColumnData(columns)
                }
            }).catch(err => {
            })
            setIsLoading(false)
        } catch (err) {
            setIsLoading(false)

        }
    }
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = tableData
        // ?.slice(itemOffset, endOffset)
        ?.map((obj, key) => { return { ...obj, id: key } });
    const pageCount = Math.ceil(
        tableData?.length / itemsPerPage
    );
    const handlePageChange = (event, value) => {
        const newOffset = (value - 1) * itemsPerPage;
        setItemOffset(newOffset);
        setCurrentPage(value);
    };
    return (
        <>
            {/* {
                !isShow &&
                <Container maxWidth="lg" >
                    <Card sx={{
                        width: "100%",
                        textAlign: "start",
                        borderRadius: "8px",
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        boxShadow: "none",
                        padding: 2,
                        background: "#fff",
                    }}>
                        <Typography variant='h5' fontWeight={600} sx={{ textAlign: "center", width: '100%' }}>Please Login to Continue</Typography>
                        <Typography variant="body1" sx={{ textAlign: "center", width: '100%' }} fontWeight={600} paddingBottom={1}>
                            Enter Password
                        </Typography>
                        <Box
                            sx={{
                                width: '100%',
                                display: "flex",
                                flexWrap: "wrap",
                                // gap: 4,
                                paddingBottom: 4,
                                rowGap: 1,
                                flexDirection: "row",
                                alignItems: "flex-start",
                                justifyContent: "center",
                            }}
                        >
                            <Box >
                                <TextField

                                    value={passwordValue}
                                    onChange={(e) => setPasswordValue(e.target.value)}
                                    // defaultValue={`03`}
                                    placeholder='Enter your password'
                                    inputProps={{
                                        style: { fontWeight: 600 },
                                    }}
                                />

                            </Box>
                            <Box sx={{
                                width: '100%',
                                display: "flex",
                                flexWrap: "wrap",
                                // gap: 4,
                                paddingBottom: 4,

                                flexDirection: "row",
                                alignItems: "flex-start",
                                justifyContent: "center",
                            }}>
                                <Button variant='outlined' onClick={handleSubmit}>
                                    Submit
                                </Button>

                            </Box>

                        </Box>
                    </Card>

                </Container>
            }*/}
            {
                isShow &&
                <Container maxWidth="lg" >
                    <Card sx={{
                        width: "100%",
                        textAlign: "start",
                        borderRadius: "8px",
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        boxShadow: "none",
                        padding: 2,
                        background: "#fff",
                    }}>
                        <Typography variant="body1" sx={{ textAlign: "center", width: '100%' }} fontWeight={600} paddingBottom={1}>
                            Enter Query
                        </Typography>
                        <Box
                            sx={{
                                width: '100%',
                                display: "flex",
                                flexWrap: "wrap",
                                // gap: 4,
                                paddingBottom: 4,
                                rowGap: 1,
                                flexDirection: "row",
                                alignItems: "flex-start",
                                justifyContent: "center",
                            }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <TextField
                                    rows={10}
                                    multiline
                                    value={query}
                                    onChange={e => setQuery(e.target.value)}
                                    // defaultValue={`03`}
                                    placeholder='Type Query...'
                                    inputProps={{
                                        style: { fontWeight: 600 },

                                    }}
                                    fullWidth
                                />

                            </Box>
                            <Typography variant="body1" sx={{ textAlign: "center", width: '100%' }} fontWeight={600} paddingBottom={1}>
                                Enter Password
                            </Typography>
                            <Box
                                sx={{
                                    width: '100%',
                                    display: "flex",
                                    flexWrap: "wrap",
                                    // gap: 4,
                                    paddingBottom: 4,
                                    rowGap: 1,
                                    flexDirection: "row",
                                    alignItems: "flex-start",
                                    justifyContent: "center",
                                }}
                            >
                                <Box >
                                    <Input
                                        type={showPassword ? 'text' : 'password'}
                                        value={passwordValue}
                                        onChange={(e) => setPasswordValue(e.target.value)}
                                        // defaultValue={`03`}
                                        endAdornment={
                                            <InputAdornment position="end">

                                                <IconButton
                                                    aria-label={
                                                        showPassword ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    onMouseUp={handleMouseUpPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <IoEyeOff /> : <IoEye />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        placeholder='Enter your password'
                                        slotProps={{
                                            input: {
                                                style: { fontWeight: 300 },
                                            
                                            }
                                        }}


                                    />

                                </Box>
                                {/* <Box sx={{
                                width: '100%',
                                display: "flex",
                                flexWrap: "wrap",
                                // gap: 4,
                                paddingBottom: 4,

                                flexDirection: "row",
                                alignItems: "flex-start",
                                justifyContent: "center",
                            }}>
                                 <Button variant='outlined' onClick={handleSubmit}>
                                    Submit
                                </Button> 

                            </Box> */}

                            </Box>
                            <Box sx={{
                                width: '100%',
                                display: "flex",
                                flexWrap: "wrap",
                                // gap: 4,
                                paddingBottom: 4,

                                flexDirection: "row",
                                alignItems: "flex-start",
                                justifyContent: "center",
                            }}>
                                <Button variant='outlined' onClick={onClickRunQuery}>
                                    Run Query
                                </Button>

                            </Box>

                        </Box>

                    </Card>

                    <Card sx={{
                        width: "100%",
                        textAlign: "start",
                        borderRadius: "8px",
                        cursor: "pointer",

                        boxShadow: "none",
                        padding: 2,
                        background: "#fff",
                        mt: 2
                    }}>
                        {tableData.length > 0 && <QueryTable
                            columnData={columnData}
                            tableData={currentItems}

                        />

                        }
                        {isLoading &&
                            <Box sx={{
                                width: '100%',
                                display: "flex",
                                flexWrap: "wrap",
                                // gap: 4,
                                // paddingBottom: 4,

                                flexDirection: "row",
                                alignItems: "flex-start",
                                justifyContent: "center",
                            }}><CircularProgress sx={{ color: `black` }} size={70} thickness={4.5} /></Box>


                        }
                    </Card>
                </Container>
            }

        </>
    )
}

export default QueryTool
